<template>
  <section v-if="canManage" :aria-label="t('title')">
    <div class="d-flex flex-wrap align-center justify-space-between ga-3">
      <div>
        <h3 class="text-subtitle-1">{{ t("title") }}</h3>
        <p class="text-body-2 text-medium-emphasis mb-0">{{ t("hint") }}</p>
      </div>
      <v-btn size="small" variant="tonal" color="primary" prepend-icon="mdi-download" :loading="exporting" @click="exportData">
        {{ t("action") }}
      </v-btn>
    </div>
    <v-alert v-if="error" type="error" class="mt-3">{{ error }}</v-alert>
    <v-snackbar v-model="done" :timeout="3500">{{ t("done") }}</v-snackbar>
  </section>
</template>

<script>
import { downloadPersonDsar } from "@/components/ncrm/privacy/privacyWorkspaceApi.mjs";
import { hasPrivacyManagerRole } from "@/Utile/ncrmPrivacyAccess.mjs";

// GDPR S11 (GDPR-123): butonul „Exportă datele” din tabul Protecția datelor al unei persoane, montat numai pentru
// managerul Privacy (verificat și aici, nu numai de părinte; serverul refuză oricum alt rol). Descarcă fișierul JSON
// produs și auditat de server; eroarea rămâne vizibilă în secțiune.
export default {
  name: "NcrmPrivacyDsarExportAction",
  props: {
    personId: { type: [Number, String], required: true },
  },
  data() {
    return { exporting: false, done: false, error: "", canManage: hasPrivacyManagerRole(), request: 0 };
  },
  watch: {
    // Aceeași componentă e refolosită la trecerea pe altă persoană: exportul în curs al celei vechi nu mai descarcă
    // și nu mai afișează nimic lângă noua persoană.
    personId() {
      this.request += 1;
      this.exporting = false; this.done = false; this.error = "";
    },
  },
  methods: {
    t(key) {
      return this.$t(`ncrm.contacts.dataProtection.record.dsarExport.${key}`);
    },
    async exportData() {
      const request = ++this.request;
      const isCurrent = () => request === this.request;
      this.exporting = true; this.error = ""; this.done = false;
      try {
        if (await downloadPersonDsar(this.personId, { isCurrent })) this.done = true;
      } catch (error) {
        if (isCurrent()) this.error = this.t(Number(error?.response?.status) === 404 ? "notFound" : "error");
      } finally {
        if (isCurrent()) this.exporting = false;
      }
    },
  },
};
</script>
